// print our fancy name


console.log("%c" + " verokoko.de ", "color: #0000ee; font-size: xx-large; font-family: pt-sans, sans-serif;");//background: white; 


// set env 
var environment = process.env.NODE_ENV;
if(environment == 'development'){

    console.log(":::DEVELOPMENT MODE:::")
    console.log( "OS: " + navigator.userAgent);
    // console.log("Bootstrap version loaded : ", $.fn.tooltip.Constructor.VERSION)
    console.log(`Theme: ${ require('../../package.json').name } v${ require('../../package.json').version}`);
}
else{
    console.log(`Theme: ${ require('../../package.json').name } v${ require('../../package.json').version}`);
}




//jquery
// var $ = require('jquery');
// window.$ = $;
// window.jQuery = $;

//ootstrap
require('bootstrap');
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// font awesome js
//import "../../node_modules/@fortawesome/fontawesome-free/js/all.js";

// rellax / parallax
let Rellax = require('rellax');
window.Rellax=Rellax;

// _s js
require('../../js/navigation.js');
// require('../../js/customizer.js');


// import GSAP and ScrollTrigger
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap;


// 
require('./checkMobile');
// window.isMobile = isMobile;
require('./scroll.js');

require('./navbar_collapse.js');







